// src/features/unit/converters.tsx
import React from 'react';
import UnitConverter from './components/UnitConverter';

// Helper to create a converter component for a given category ID
const createConverter = (categoryId: string): React.FC => {
    // eslint-disable-next-line react/display-name
    return () => <UnitConverter categoryId={categoryId} />;
};

// Generate and export a component for each category defined in the config
export const LengthConverter = createConverter('length');
export const MassConverter = createConverter('mass');
export const AreaConverter = createConverter('area');
export const VolumeConverter = createConverter('volume');
export const TimeConverter = createConverter('time');
export const SpeedConverter = createConverter('speed');
export const AccelerationConverter = createConverter('acceleration');
export const ForceConverter = createConverter('force');
export const PressureConverter = createConverter('pressure');
export const EnergyConverter = createConverter('energy');
export const PowerConverter = createConverter('power');
export const TemperatureConverter = createConverter('temperature');
export const AngleConverter = createConverter('angle');
export const FrequencyConverter = createConverter('frequency');
export const ElectricChargeConverter = createConverter('electric_charge');
export const ElectricCurrentConverter = createConverter('electric_current');
export const VoltageConverter = createConverter('voltage');
export const ResistanceConverter = createConverter('resistance');
export const ConductanceConverter = createConverter('conductance');
export const MagneticFluxConverter = createConverter('magnetic_flux');
export const MagneticFieldStrengthConverter = createConverter('magnetic_field_strength');
export const DensityConverter = createConverter('density');
export const ConcentrationConverter = createConverter('concentration');
export const RadiationDoseConverter = createConverter('radiation_dose');